export default __webpack_public_path__ + "static/media/burger-icon.c07d50a2.svg";